export const locales = {
	errorCodeText: 'Code d\'erreur\xa0: ',
	supportIdMessage: 'Votre identifiant de support\xa0:',
	btnText: 'Retour à l’accueil'
};
